import React from 'react';
import styled from 'styled-components';
import CarouselGrind from './CarouselGrind';
import StackGrind from './StackGrind';
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const TitleRow = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.5rem 1.5rem;
    padding: 0 calc(2rem + 1vw);
    margin: 0 0 1rem 0;
`;

const ProjectLink = styled.a`
    display: inline-block;
    color: #a1a1a1;
    text-decoration: none;
    font-size: clamp(0.85rem, 0.6vw + 0.35rem, 1.1rem);
    font-weight: 700;
    letter-spacing: 0.05em;
    cursor: pointer;
    border-bottom: 1px solid transparent;
    padding-bottom: 2px;
    white-space: nowrap;
    transition: color 0.25s, border-color 0.25s;

    &:hover {
        color: #ffffff;
        border-bottom-color: rgba(255, 255, 255, 0.5);
    }
`;

const Container = styled.div`
    margin-top: 2rem;
    border-radius: 1rem;
    padding-block-end: 2rem;
    padding-block-start: 2rem;
    background-color: #121212;
    background-image: url(${process.env.PUBLIC_URL}/img/GrindVector.svg);
    background-repeat: no-repeat;
    background-position: 0% 30%;
    background-size: 75rem;
    opacity: 0;
    transform: translateY(2.5rem);
    transition: opacity 0.7s cubic-bezier(0.23, 1, 0.32, 1),
        transform 0.7s cubic-bezier(0.23, 1, 0.32, 1);

    &.visible {
        opacity: 1;
        transform: translateY(0);
    }

    h1 {
        margin: 0;
        padding: 0;
        font-size: clamp(1.6rem, 2.5vw + 0.5rem, 2.75rem);
        font-weight: 900;
    }

    p {
        padding: 0 calc(2rem + 1vw) 0 calc(2rem + 1vw);
        margin-top: 0;
        font-size: clamp(1rem, 1vw + 0.3rem, 1.3rem);
    }
`;

const ProjectGrind = () => {
    const [ref, isVisible] = useScrollAnimation();
    return (
        <Container ref={ref} className={isVisible ? 'visible' : ''}>
            <TitleRow>
                <h1>GRIND (2022)</h1>
                <ProjectLink href='#' target='_blank' rel='noreferrer'>
                    → visit project
                </ProjectLink>
            </TitleRow>
            <p>project to find a direction and a university for applicants</p>
            <CarouselGrind />
            <StackGrind />
        </Container>
    );
};

export default ProjectGrind;
